import { Action } from '@/_core/fluxstore/types';
import { AccountState } from '../types';
import { useAccountStore } from '../useModule';
import { useSendCommand } from '@/_core/cqrs/use';

import { RevokeApiToken as RevokeApiTokenCommand } from '@/api/account/commands';

const { registerMiddleware, registerReducer } = useAccountStore();

export class RevokeApiToken extends Action<AccountState> {
    public static ACTION_TYPE = 'RevokeApiToken';

    public constructor() {
        super(RevokeApiToken.ACTION_TYPE);
    }
}

const middleware = async (state: AccountState, action: RevokeApiToken): Promise<boolean> => {
    return await useSendCommand(action, {
        createCommand: () => new RevokeApiTokenCommand(),
    });
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const reducer = (state: AccountState, action: RevokeApiToken): void => {
    state.apiToken = null;
    state.apiTokenGeneratedAt = null;
};

//@ts-ignore
registerMiddleware(RevokeApiToken.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(RevokeApiToken.ACTION_TYPE, reducer);
